import { useState, useEffect } from 'react';
import { useRefinementList } from 'react-instantsearch';
import { FilterSwitch } from '@fagmobler/ui';

import { useStores } from '@/components/store';
import { useNavigation } from '@/contexts/navigation';

type StockFilterProps = {
  showDescription?: boolean;
};

export function StockFilter({ showDescription = true }: StockFilterProps) {
  const { current } = useStores();
  const currentStoreId = current?.data?.store?.id;
  const currentStore = current?.data?.store;

  const { items, refine, canRefine } = useRefinementList({
    attribute: 'storesWithStockOrDisplay',
    operator: 'or',
  });

  const { setShowStores } = useNavigation();

  const handleChange = (checked: boolean) => {
    if (!canRefine || !currentStoreId) {
      console.error('Cannot refine');
      return;
    }

    if (checked && currentStoreId) {
      refine(currentStoreId);
    } else {
      refine(currentStoreId);
    }
  };

  const isChecked = items.some(
    (item) => item.value === currentStoreId && item.isRefined
  );

  return (
    <FilterSwitch
      title={'Lagerstatus'}
      onChange={handleChange}
      checked={isChecked}
      disabled={!currentStore || !canRefine}
      classNames={{
        container: 'border-b border-neutral-40 pb-6 pt-2',
      }}
    >
      <div className="mt-5 ml-5">
        {currentStore?.name && showDescription && (
          <div>
            <p className="cap-sm">
              Vis kun produkter som {currentStore.name} har på lager.
            </p>
            <button
              className="mt-2 underline cap-link-xs underline-offset-4"
              onClick={() => setShowStores(true)}
            >
              Endre butikk
            </button>
          </div>
        )}

        {!currentStore?.name && <p>Velg butikk for å filtrere på lager</p>}
        {!currentStore && (
          <button
            onClick={() => setShowStores(true)}
            className="mt-2 underline cap-link-xs"
          >
            Velg butikk
          </button>
        )}
      </div>
    </FilterSwitch>
  );
}
